define([], function () {

    return ['$q', 'JsonRPCService', function ($q, JsonRPCService) {
        return {
            findByCertificateNumber: function (callGroups, certificateNumber, firstRegistrationDate) {
                var deferred = $q.defer();
                JsonRPCService.send('vinlookup', 'vinlookup', 'findByCertificateNumber', [certificateNumber, firstRegistrationDate], callGroups).then(
                    function (response) {
                        var vinResult = response;
                        return deferred.resolve(vinResult);
                    }, function (error, status, headers) {
                        return deferred.reject([error, status, headers]);
                    });
                return deferred.promise;
            },
            findMakes: function (callGroups, categories, firstRegistrationDate) {
                var deferred = $q.defer();
                JsonRPCService.send('vinlookup', 'vinlookup', 'findMakes', [categories, firstRegistrationDate], callGroups).then(
                    function (response) {
                        var vinResult = response;
                        return deferred.resolve(vinResult);
                    }, function (error, status, headers) {
                        return deferred.reject([error, status, headers]);
                    });
                return deferred.promise;
            },
            findModels: function (callGroups, modelRequestDTO, firstRegistrationDate) {
                var deferred = $q.defer();
                JsonRPCService.send('vinlookup', 'vinlookup', 'findModels', [modelRequestDTO, firstRegistrationDate], callGroups).then(
                    function (response) {
                        var vinResult = response;
                        return deferred.resolve(vinResult);
                    }, function (error, status, headers) {
                        return deferred.reject([error, status, headers]);
                    });
                return deferred.promise;
            },
            findVehicles: function (callGroups, VehiclesLookupRequestDTO, firstRegistrationDate) {
                var deferred = $q.defer();
                JsonRPCService.send('vinlookup', 'vinlookup', 'findVehicles', [VehiclesLookupRequestDTO, firstRegistrationDate], callGroups).then(
                    function (response) {
                        var vinResult = response;
                        return deferred.resolve(vinResult);
                    }, function (error, status, headers) {
                        return deferred.reject([error, status, headers]);
                    });
                return deferred.promise;
            }
        };
    }];
});


// WEBPACK FOOTER //
// ../common/js/src/edge/policyjob/services/VinLookupService.js